/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable template-curly-spacing */
import React, { Component } from 'react';
import moment from 'moment';
import Table from 'view/component/Table';
import { confirmedAlert } from '../../../view/component/Alert';
import Alert from '../../../view/component/Alert';
import API from 'apiService';
import ModalAdd from './modalAdd';

export default class Club extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      isLoading: true,
      modalShow: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const res = await API.get('registration/prolanis/get-club/01');
    if (res.response) this.setState({ datas: res.response.list, isLoading: false });
    else this.setState({ isLoading: false });
  };

  deleteData = async (id) => {
    const res = await API.delete(`registration/kesling/delete/${id}`);
    if (res.code === 200) {
      Alert('success', 'data dihapus');
      this.getData();
    }
    else Alert('error', 'gagal menghapus data');
  };

  createActionButton = (data) => {
    return (
      <div>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => this.setState({ data, modalShow: true })}>
          Edit
        </button>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => confirmedAlert(
            'Konfirmasi',
            'Apakah anda akan menghapus data status kesehatan lingkungan?',
            confirmed => {
              if (confirmed) this.deleteData(data.id);
            }
          )}>
          Hapus
        </button>
      </div>
    );
  }

  render() {
    const { datas, isLoading, data, modalShow } = this.state;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Club Prolanis</h4>
              </div>
              <div className="col-4 text-right">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  data-toggle="collapse"
                  data-target="#collapsePreview"
                  aria-expanded="false"
                  aria-controls="collapsePreview"
                  onClick={() => this.setState({ modalShow: true })}
                >
                  <span className="btn-inner--text">Tambah Data</span>
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-12'>
                <Table
                  headers={[
                    'No',
                    'Kelompok',
                    'Nama',
                    'tanggal mulai',
                    'tanggal selesai',
                    'nama ketua',
                    'no. hp ketua',
                    'alamat',
                    'Aksi',
                  ]}
                  isLoading={isLoading}
                  data={datas}
                  columnMapper={(item) => [
                    item.nama,
                    item.jnsKelompok.nmProgram,
                    item.tglMulai && moment(item.tglMulai).format('DD-MM-YYYY'),
                    item.tglAkhir && moment(item.tglAkhir).format('DD-MM-YYYY'),
                    item.ketua_nama,
                    item.ketua_noHP,
                    item.alamat,
                    this.createActionButton(item),
                  ]}
                  pagination={true}
                />
              </div>
            </div>
          </div>
        </div>
        <ModalAdd
          data={data}
          show={modalShow}
          onHide={() => {
            this.setState({ modalShow: false })
            this.getData();
          }}
        />
      </div>
    );
  }
}
